export default "__VITE_ASSET__83d0c1e4__"